/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";
import {
    onDtStartChange,
    onDtEndChange,
    onToggleBulk,
    onSetBulkLine,
    onSetBulkWorkorder,
    onSetBulkBatch,
    onSetBulkLot,
    onSetBulkStartRank,
    onSetBulkEndRank,
    onSetShowAllPallets,
    onSetBulkStatus,
    onSetBulkCondition,
    onSetBulkMaterial,
    onSetQualitySwitch,
    onSetSsccSearch
} from "../../redux/slices/palletCache.feature";
import redDotGif from "../../i/red-dot.gif";
import { getBlockedPallets } from "../../aplApi/palletsHelper";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { sanitizeBarcode } from "../../aplApi/palletsHelper";
import { onlyOnEnter } from "../../aplUtils/aplDebounce";

import { useAppDispatch } from "../../redux/hooks";
import { IRootState } from "../../types/redux/IRootStore";
import { useTranslation } from "react-i18next";
import { UserPermission } from "../../types/userPermission";
import { UserPermissions } from "../../aplUtils/permissions";
import DateSelector3 from "../common/DateSelector3";
import PalstatSearchStatusDropdown from "./PalstatSearchStatusDropdown";
import PalstatSearchConditionDropdown from "./PalstatSearchConditionDropdown";
import { translateString } from "../../translations/gridTranslationHelper";

export default function PalstatSearch(props: { handleBlockClick: () => void; handleSearch: () => void }) {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const aplSettings = AplSettingsSelector();

    const palletCacheRedux = useSelector((state: IRootState) => ({ ...state.palletCache }));
    const palletSearchRedux = useSelector((state: IRootState) => state.palletCache.palletSearch);

    const searchSccc = (barcode: string) => {
        if (sanitizeBarcode(barcode)) {
            navigate(`/palstat/edit/${aplSettings.siteId}/${sanitizeBarcode(barcode)}`);
        }
    };

    const searchSsccRef = React.createRef() as React.RefObject<HTMLInputElement>;

    return (
        <React.Fragment>
            <div className="row" id="data-search-row">
                <div className="col-6">
                    <div className="input-group mb-3">
                        <DateSelector3
                            name="date-input-start"
                            culture={aplSettings.culture}
                            onSetSelectedDate={(e: any) => {
                                dispatch(onDtStartChange(e));
                            }}
                            selectedDate={moment(palletSearchRedux.dateStartSelectorDate).toDate()}
                            small={true}
                        />

                        <DateSelector3
                            name="date-input-end"
                            culture={aplSettings.culture}
                            onSetSelectedDate={(e: any) => {
                                dispatch(onDtEndChange(e));
                            }}
                            selectedDate={moment(palletSearchRedux.dateEndSelectorDate).toDate()}
                            small={true}
                        />
                        <div className="input-group-append">
                            <button
                                id="btn-search"
                                className="btn btn-sm btn-primary"
                                type="button"
                                onClick={() => {
                                    props.handleSearch();
                                }}
                            >
                                {t("main.search")}
                            </button>
                            {aplSettings.permissions.some(x =>
                                [
                                    UserPermission.MassPalAddDefect,
                                    UserPermission.MassPalBlockQI,
                                    UserPermission.MassPalBlockResort,
                                    UserPermission.MassPalEdit,
                                    UserPermission.MassPalRemoveDefect,
                                    UserPermission.MassPalRemoveDefect,
                                    UserPermissions.MassPalUnBlock
                                ].includes(x.userPermission)
                            ) || palletSearchRedux.bulk ? (
                                <Link
                                    id="btn-mass-activities"
                                    className={`btn btn-sm nowrap ${palletSearchRedux.bulk ? "btn-danger" : "btn-primary"}`}
                                    role="button"
                                    onClick={() => {
                                        dispatch(onToggleBulk());
                                    }}
                                    to={""}
                                >
                                    {t("main.massActivities")}
                                </Link>
                            ) : null}

                            <button
                                id="btn-quality"
                                className={`btn btn-sm ${palletSearchRedux.qualitySwitch ? "btn-danger" : "btn-primary"}`}
                                onClick={() => {
                                    dispatch(onSetQualitySwitch(!palletSearchRedux.qualitySwitch));
                                }}
                            >
                                {t("main.quality")}
                            </button>
                            <button
                                id="btn-show-all-pallets"
                                className={`btn btn-sm ${palletSearchRedux.showAllPallets ? "btn-danger" : "btn-primary"}`}
                                onClick={() => {
                                    dispatch(onSetShowAllPallets(!palletSearchRedux.showAllPallets));
                                }}
                            >
                                {t("main.allPallets")}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="col-3">
                    {getBlockedPallets(palletCacheRedux.selectedPallets).length > 0 ? (
                        <div
                            id="defectsTriangle"
                            className="d-flex justify-content-center align-content-center margin-top03em"
                            onClick={props.handleBlockClick}
                        >
                            <Link title=" Defects" id="defectsTriangleIcon" style={{ display: "inline" }} to={""}>
                                <img alt="Defects" src={redDotGif} />
                            </Link>
                            &nbsp;
                            <span id="defectsTriangleImg" style={{ display: "inline" }}>
                                {t("main.defects")}
                            </span>
                            &nbsp;
                            <span id="defectsTriangleSscc" style={{ display: "inline" }}>
                                {getBlockedPallets(palletCacheRedux.selectedPallets).sort(x => x.sscc as any)[0].sscc ?? ""}
                            </span>
                            &nbsp;
                        </div>
                    ) : (
                        <div></div>
                    )}
                </div>

                <div className="col-3">
                    <div className="input-group mb-3">
                        <input
                            type="text"
                            id="txt-sscc-search"
                            className="form-control form-control-sm"
                            placeholder="SSCC"
                            aria-label="sscc"
                            aria-describedby="sscc-search"
                            ref={searchSsccRef as any}
                            onKeyDown={e => {
                                onlyOnEnter(e, () => {
                                    searchSccc(e.currentTarget.value);
                                });
                            }}
                            onChange={e => {
                                dispatch(onSetSsccSearch(e.currentTarget.value));
                            }}
                        />
                        <div className="input-group-append">
                            <button
                                id="btn-sscc-search"
                                className="btn btn-sm btn-primary"
                                type="button"
                                onClick={e => {
                                    searchSccc(palletSearchRedux.ssccSearch);
                                }}
                            >
                                {t("main.search")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {palletSearchRedux.bulk ? (
                <React.Fragment>
                    <div className="row">
                        <div className="col">
                            <div className="form-row">
                                <div className="col">
                                    <input
                                        name="txtLine"
                                        type="text"
                                        id="txtLine"
                                        className="form-control"
                                        placeholder={translateString("line", aplSettings.culture)}
                                        value={palletSearchRedux.bulkLine}
                                        onChange={e => {
                                            dispatch(onSetBulkLine(e.currentTarget.value));
                                        }}
                                        onKeyDown={e => {
                                            onlyOnEnter(e, () => {
                                                props.handleSearch();
                                            });
                                        }}
                                    />
                                </div>
                                <div className="col">
                                    <input
                                        name="txtWorkorder"
                                        type="text"
                                        id="txtWorkorder"
                                        className="form-control"
                                        placeholder={translateString("workOrder", aplSettings.culture)}
                                        value={palletSearchRedux.bulkWorkorder}
                                        onChange={e => {
                                            dispatch(onSetBulkWorkorder(e.currentTarget.value));
                                        }}
                                        onKeyDown={e => {
                                            onlyOnEnter(e, () => {
                                                props.handleSearch();
                                            });
                                        }}
                                    />
                                </div>
                                <div className="col">
                                    <input
                                        name="txtBatch"
                                        type="text"
                                        id="txtBatch"
                                        className="form-control"
                                        placeholder={translateString("batch", aplSettings.culture)}
                                        value={palletSearchRedux.bulkBatch}
                                        onChange={e => {
                                            dispatch(onSetBulkBatch(e.currentTarget.value));
                                        }}
                                        onKeyDown={e => {
                                            onlyOnEnter(e, () => {
                                                props.handleSearch();
                                            });
                                        }}
                                    />
                                </div>
                                {!aplSettings.isUsSite && (
                                    <div className="col">
                                        <input
                                            name="txtLot"
                                            type="text"
                                            id="txtLot"
                                            className="form-control"
                                            placeholder={translateString("lot", aplSettings.culture)}
                                            value={palletSearchRedux.bulkLot}
                                            onChange={e => {
                                                dispatch(onSetBulkLot(e.currentTarget.value));
                                            }}
                                            onKeyDown={e => {
                                                onlyOnEnter(e, () => {
                                                    props.handleSearch();
                                                });
                                            }}
                                        />
                                    </div>
                                )}

                                <div className="col">
                                    <input
                                        name="txt-material"
                                        type="text"
                                        id="txt-material"
                                        className="form-control"
                                        placeholder={translateString("material", aplSettings.culture)}
                                        value={palletSearchRedux.bulkMaterial}
                                        onChange={e => {
                                            dispatch(onSetBulkMaterial(e.currentTarget.value));
                                        }}
                                        onKeyDown={e => {
                                            onlyOnEnter(e, () => {
                                                props.handleSearch();
                                            });
                                        }}
                                    />
                                </div>
                                <div className="col">
                                    <input
                                        name="txtRankMin"
                                        type="number"
                                        id="txtRankMin"
                                        className="form-control"
                                        placeholder={translateString("startingPalletRank", aplSettings.culture)}
                                        value={palletSearchRedux.bulkStartRank ?? ""}
                                        onChange={e => {
                                            dispatch(onSetBulkStartRank(e.currentTarget.valueAsNumber));
                                        }}
                                        onKeyDown={e => {
                                            onlyOnEnter(e, () => {
                                                props.handleSearch();
                                            });
                                        }}
                                    />
                                </div>
                                <div className="col">
                                    <input
                                        name="txtRankMax"
                                        type="number"
                                        id="txtRankMax"
                                        className="form-control"
                                        placeholder={translateString("finalPalletRank", aplSettings.culture)}
                                        value={palletSearchRedux.bulkEndRank ?? ""}
                                        onChange={e => {
                                            dispatch(onSetBulkEndRank(e.currentTarget.valueAsNumber));
                                        }}
                                        onKeyDown={e => {
                                            onlyOnEnter(e, () => {
                                                props.handleSearch();
                                            });
                                        }}
                                    />
                                </div>
                                <div className="col">
                                    <PalstatSearchStatusDropdown
                                        culture={aplSettings.culture}
                                        onChange={e => {
                                            dispatch(onSetBulkStatus(e.currentTarget.value));
                                        }}
                                    />
                                </div>
                                <div className="col">
                                    <PalstatSearchConditionDropdown
                                        culture={aplSettings.culture}
                                        onChange={e => {
                                            dispatch(onSetBulkCondition(e.currentTarget.value));
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                </React.Fragment>
            ) : (
                ""
            )}
        </React.Fragment>
    );
}
